<template>
  <div class="drops" :style="'width:' + 30 * size + 'px;' + cssVal">
    <div class="drop wow" :data-wow-delay="dropFilter(k)" data-wow-offset="-100000" v-for="(v, k) in this.size * this.size" :key="k"></div>
  </div>
</template>

<script>
export default {
  props: {
		size: {
			type: Number,
			default: 8,
		},
    cssVal: String,
  },
  methods: {
    dropFilter(k) {
			var row = Math.floor(k % this.size);
			var col = Math.floor(k / this.size);
			var time = (col > row ? col : row) * 0.1;
			return time + 's';
		},
  }
}
</script>

<style lang="scss" scoped>
  .drops{
		position: absolute;
		width: 240px;
		font-size: 0;
		.drop{
			width: 9px;
			height: 9px;
			background: #ffa147;
			border-radius: 50%;
			display: inline-block;
			margin-right: 18px;
			margin-bottom: 18px;
		}
	}
</style>